import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Routes from './Routes';
import ScrollToTop from '../components/common/ScrollToTop';
import CanonicalLink from '../components/CanonicalLink';

const Router = () => {
  return (
    <BrowserRouter>
      <ScrollToTop>
        <CanonicalLink />
        <Routes />
      </ScrollToTop>
    </BrowserRouter>
  );
};

export default Router;
